import styled from "styled-components";
import React from "react";

const SelectGroupDiv = styled.div`
  display: flex;
  .grouped-select {
    &:not(:last-child) {
      margin-right: -1px;
      .grouped-select__control {
        border-top-right-radius: 0;
        border-bottom-right-radius: 0;
      }
    }
    &:not(:first-child) {
      .grouped-select__control {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0;
      }
    }
    &:focus {
      background-color: red;
    }
  }
`;

export default function SelectGroup(props) {
  return <SelectGroupDiv {...props}>
    {React.Children.map(props.children, (child) => {
      if (React.isValidElement(child)) {
        return React.cloneElement(child, {...child.props, className: "grouped-select", classNamePrefix: "grouped-select"})
      }
    })}
  </SelectGroupDiv>
}

SelectGroup.propTypes = {

}
